import React, { Component } from 'react';

class WaitingSelection extends Component {

    render() {
        return (
            <div className="waiting-team-select">
                <h3>Select a Team!</h3>
                <h1> ← </h1>
            </div>
        );
    }
}

export default WaitingSelection;